
const projectSettings = {
	breakpointSM: 576,
	breakpointMD: 769,
	breakpointLG: 992,
	breakpointXL: 1300,
};

export default projectSettings;
